import React from 'react';
import moment from 'moment';
import TWModal from '../ui/tw-modal';

export default function ModalUserList({
  title,
  headers,
  keys,
  list,
  open,
  onCloseRequest,
}) {
  const renderCell = (x, element) => {
    if (x === 'status') {
      const v = element.user[x];
      return v === 0 ? 'Pending' : v === 10 ? 'Active' : 'Passive';
    }
    if (x === 'createdate') {
      return moment
        .utc(element.user[x])
        .local()
        .format('MM/DD/YYYY hh:mm A');
    }
    if (x === 'userroles') {
      return element.user?.userroles[0]?.role?.name;
    }
    return element.user[x];
  };

  return (
    <TWModal
      open={open}
      onClose={onCloseRequest}
      title={title}
      size="2xl"
      showCloseButton
      bodyClassName="px-4 py-4 sm:px-6 sm:py-5"
    >
      <div className="min-h-[250px] overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-600">
          <thead>
            <tr>
              {headers.map((head, headIdx) => (
                <th
                  key={headIdx}
                  scope="col"
                  className="py-3 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400"
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 dark:divide-slate-700/60">
            {list.map((element, idx) => (
              <tr key={idx}>
                {keys.map((x, keyIdx) => (
                  <td
                    key={keyIdx}
                    className="whitespace-nowrap px-3 py-3.5 text-sm font-medium text-slate-900 dark:text-slate-100"
                  >
                    {renderCell(x, element)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </TWModal>
  );
}
